import { presentationApi } from '../../../api/presentation.js';
import { telechargerUrlSignee } from '../../../api/client.js';
import { capturerPortee, exigerActuelle, PorteeObsolete } from '../../../auth/identite.js';
import type { PorteeFile } from '../../stand/fileHorsLigne.js';
import type { MagasinPresentation, PreparationPresentation } from './magasin.js';

export interface ProgressionPresentation {
  readonly faites: number;
  readonly total: number;
  readonly octets: number;
}
export async function preparerPresentation(
  magasin: MagasinPresentation,
  portee: PorteeFile,
  selectionId: string,
  progression: (etat: ProgressionPresentation) => void,
): Promise<PreparationPresentation> {
  const capture = capturerPortee();
  if (capture.compteId !== portee.compteId || capture.galerieSlug !== portee.galerieSlug)
    throw new PorteeObsolete();
  const charge = await presentationApi.presenter(portee.galerieSlug, selectionId, {
    signal: capture.signal,
    compteAttendu: portee.compteId,
  });
  exigerActuelle(capture);
  const urls = [
    ...new Set(charge.elements.flatMap((element) => (element.imageUrl ? [element.imageUrl] : []))),
  ];
  const images = new Map<string, Blob>();
  let octets = new TextEncoder().encode(JSON.stringify(charge)).byteLength;
  progression({ faites: 0, total: urls.length, octets });
  for (const url of urls) {
    const image = await telechargerUrlSignee(url, capture.signal);
    exigerActuelle(capture);
    images.set(url, image);
    octets += image.size;
    progression({ faites: images.size, total: urls.length, octets });
  }
  exigerActuelle(capture);
  const preparation = await magasin.preparer(portee, charge, images);
  // Une purge pendant l’écriture interdit de republier des données de l’ancienne session.
  if (capture.signal.aborted) {
    await magasin.effacer(portee, selectionId);
    throw new PorteeObsolete();
  }
  return preparation;
}
